import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';
import { NumericQuestionConfig } from '@hyper-inferno/numeric-core';
import { QuestionAnswerObject, SurveyElement } from '@hyper-inferno/survey-elements-core';

export class NumericHandler implements QuestionHandler<NumericQuestionConfig> {
  async buildConfig(el: any, ctx: ITransformationContext) {
    return el.config;
  }

  getValue(el: SurveyElement, response: QuestionAnswerObject) {
    const key = el.name;
    return response[key] ?? ''; // returns number
  }
}
